import axios from '../jslib/http'
const BASE_REQUEST = '/oa/sysUserRole'



export function getUserRoles(userid) {
    const url = `${BASE_REQUEST}/getUserRoles`
    var data = {
        userid:userid
    }
    return axios
        .get(url, {
            params: data
        })
        .then(res => {
            if (res !== undefined) {
                return Promise.resolve(res.data)
            } else {
                return Promise.resolve(res)
            }
        })
}

export function saveUserRoles(userid,roleids) {
    const url = `${BASE_REQUEST}/saveUserRoles`
    var data = {
        userid:userid,
        roleids:roleids
    }
    return axios
        .get(url, {
            params: data
        })
        .then(res => {
            if (res !== undefined) {
                return Promise.resolve(res.data)
            } else {
                return Promise.resolve(res)
            }
        })
}